// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import React, { useCallback } from "react"
import { IconButton as MuiIconButton } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"

import { useTableContext } from "../../provider"
import { mapDrawerData } from "./mapDrawerData"

export const IconColumn = (params: any) => {

  const ctx = useTableContext()
  const { setData, setOpen } = ctx.drawer.api

  const onClick = (event) => {
    event.stopPropagation()

    if (!ctx.props.drawerFields) return

    const { details, overview, title, transformTitle } = ctx.props.drawerFields
    const drawerContent = {
      details: mapDrawerData(details, params.row, i18n),
      overview: mapDrawerData(overview, params.row, i18n),
      title: transformTitle?.(params.row[title]) || params.row[title],
    }
    setData(drawerContent)
    setOpen(true)
  }

  const onClick_ = useCallback(onClick, [params.row])

  return (
    <MuiIconButton onClick={onClick_}>
      <InfoOutlined />
    </MuiIconButton>
  )
}
